// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { Formik, Form, Field, ErrorMessage } from "formik";
// import * as Yup from "yup";
// import axios from "../../utils/AxiosInstance";
// import "./auth.css";

// const ResetPassword = () => {
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const email = localStorage.getItem("resetEmail");

//   const initialValues = {
//     otp: "",
//     newPassword: "",
//   };

//   const validationSchema = Yup.object({
//     otp: Yup.string().required("OTP is required"),
//     newPassword: Yup.string()
//       .required("New Password is required")
//       .min(6, "Password must be at least 6 characters"),
//   });

//   const handleReset = async (values, { setSubmitting }) => {
//     setLoading(true);
//     try {
//       const res = await axios.post("/auth/admin/reset-password", {
//         email,
//         otp: values.otp,
//         newPassword: values.newPassword,
//       });

//       if (res.status === 200) {
//         localStorage.removeItem("resetEmail");
//         toast.success(res.data.data.message);
//         navigate("/login");
//       }
//     } catch (err) {
//       const msg = err.response?.data?.message || "OTP or PASSWORD IS WRONG";
//       toast.error(msg);
//     } finally {
//       setLoading(false);
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div className="login-container">
//       <h2>Reset Password</h2>

//       <Formik
//         initialValues={initialValues}
//         validationSchema={validationSchema}
//         onSubmit={handleReset}
//       >
//         {({ isSubmitting }) => (
//           <Form>
//             <Field
//               type="text"
//               name="otp"
//               placeholder="Enter OTP"
//               className="form-control"
//             />
//             <ErrorMessage
//               name="otp"
//               component="div"
//               className="text-danger mb-2"
//               style={{ color: "red" }}
//             />

//             <Field
//               type="password"
//               name="newPassword"
//               placeholder="Enter New Password"
//               className="form-control"
//             />
//             <ErrorMessage
//               name="newPassword"
//               component="div"
//               className="text-danger mb-2"
//               style={{ color: "red" }}
//             />

//             <button
//               type="submit"
//               disabled={isSubmitting || loading}
//               style={{ marginTop: "10px" }}
//             >
//               {loading ? "Please wait..." : "Reset-Password"}
//             </button>
//           </Form>
//         )}
//       </Formik>
//     </div>
//   );
// };

// export default ResetPassword;
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "../../utils/AxiosInstance";
import "./auth.css";

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const email = localStorage.getItem("resetEmail");

  const initialValues = {
    otp: "",
    newPassword: "",
  };

  const validationSchema = Yup.object({
    otp: Yup.string().required("OTP is required"),
    newPassword: Yup.string()
      .required("New Password is required")
      .min(6, "Password must be at least 6 characters"),
  });

  const handleReset = async (values, { setSubmitting }) => {
    setLoading(true);
    try {
      const res = await axios.post("/auth/admin/reset-password", {
        email,
        otp: values.otp,
        newPassword: values.newPassword,
      });

      if (res.status === 200) {
        localStorage.removeItem("resetEmail");
        toast.success(res.data.data.message);
        navigate("/login");
      }
    } catch (err) {
      const msg = err.response?.data?.message || "OTP or PASSWORD IS WRONG";
      toast.error(msg);
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">Reset Password</div>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleReset}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="form-group">
                <Field
                  type="text"
                  name="otp"
                  placeholder="Enter OTP"
                  className="styled-field"
                />
                <ErrorMessage
                  name="otp"
                  component="div"
                  className="error-text"
                />
              </div>

              <div className="form-group">
                <Field
                  type="password"
                  name="newPassword"
                  placeholder="Enter New Password"
                  className="styled-field"
                />
                <ErrorMessage
                  name="newPassword"
                  component="div"
                  className="error-text"
                />
              </div>

              <button
                type="submit"
                className="submit-button"
                disabled={isSubmitting || loading}
              >
                {loading ? "Please wait..." : "Reset Password"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default ResetPassword;
